import type { WalterLivingAddress } from "../types";

export const getDisplayStreet = (address: WalterLivingAddress) =>
  `${address.street} ${address.number}${address.extension ? `-${address.extension?.toUpperCase()}` : ""}`;
